module.exports = __webpack_public_path__ + "img/ilona-smc.584bf263.jpg";